import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { EnumListResponse } from '../model/response/enum-list.response';

@Injectable()
export class AdminEnumApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchRegistrations() {
    return this.http.get<EnumListResponse>(
      this.baseUrl + '/api/cf/administration/enum/registrations',
      {headers: this.getAuthHeaders()}
    );
  }
}
